import { makeStyles } from "@mui/styles"

export const useStyles = makeStyles(() => ({
  columnHeader: ({ disallowSelectAll, selectAllToPage }) => ({
    "& .MuiCheckbox-root": {
      display: disallowSelectAll && !selectAllToPage ? "none" : "inherit",
    },
    "& [class*='columnHeaderDraggableContainer']": {
      cursor: "pointer",
    },
    "&:last-child > div > div:last-child button, &:last-child > div > div:last-child": {
      visibility: "visible",
      width: "auto",
    },
    "&[aria-sort='descending'], &[aria-sort='ascending']": {
      background: "#efefef",
    },
    "&[class*='sortable']": {
      "& [class*='iconButtonContainer'] [class*='MuiSvgIcon']": {
        color: "#9B9B9B",
      },
      "& [class*='iconButtonContainer'] button": {
        display: "inline-flex",
      },
      "& [class*='iconButtonContainer'] button:hover": {
        display: "inline-flex",
      },
      "&:hover": {
        "& [class*='iconButtonContainer']": {
          visibility: "visible",
          width: "auto",
        },
        "& [class*='iconButtonContainer']:hover": {
          visibility: "visible !important",
          width: "auto !important",
        },
        backgroundColor: "#ececec",
      },
      "&[class*=moving]": {
        "& [class*='iconButtonContainer']": {
          display: "none",
        },
        width: "100%",
      },
    },
    "&[data-field='custom']": {
      "& .MuiSvgIcon-root": {
        color: "#9B9B9B",
      },
      "& [class*='menuOpen']": {
        pointerEvents: "none",
      },
    },
  }),
  columnSeparator: {
    visibility: "hidden",
  },
  first: {
    // padding: "3.5px 16px 3.5px 4px !important",
    // fontWeight: "bold",
  },
  header: {
    "& div": {
      display: "flex",
      justifyContent: "space-between",
    },

    backgroundColor: "#f9f9f9",
    color: " #9b9b9b",
    fontSize: "12px",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  icon: {
    marginLeft: "-5px",
    overflow: "hidden",
  },
  noResults: {
    color: "#c1bebe",
    fontSize: "15px",
    padding: "20px 0 20px 30px",
  },
  notification: {
    "& > [class*='title']": {
      fontWeight: "normal !important",
    },
    "& > button": {
      fontSize: "14px",
      fontWeight: "bold",
    },
    "& > div": {
      border: "none !important",
      fontSize: "12px",
      justifyContent: "center !important",
      maxWidth: "unset !important",
      width: "auto",
    },
    "& > span": {
      fontSize: "14px",
      verticalAlign: "middle",
    },
    "&:hover": {
      backgroundColor: "#f9f9f9 !important",
    },

    backgroundColor: "#f9f9f9",
    display: "block !important",
    height: "53px",
    lineHeight: "53px",
    margin: "5px 0",
    textAlign: "center",
    width: "auto !important",
  },
  paper: ({ border }) => ({
    "& .MuiDrawer-paperAnchorRight": {
      height: "calc(100% - 109px)",
      right: "-1px",
      top: "56px",
      overflowX: "hidden",
      zIndex: "10",
    },

    "& .searchField, & .searchField .MuiFilledInput-root": {
      width: "225px",
    },

    "&[class*='MuiPaper-root']": {
      "& .MuiToolbar-root": {
        height: "44px",
      },
      border: border || "1px solid #EBEBEB",
      borderTop: "none",
      borderRadius: 0,
      boxShadow: "none",
    },

    minHeight: "100%",
    overflow: "hidden",
    padding: "20px 32px",
    position: "relative",
  }),
  root: ({ wrapInline }) => ({
    "& *": {
      outline: "none !important",
    },

    "& .MuiDataGrid-autoHeight, &.MuiDataGrid-autoHeight": {
      minHeight: "calc(100vh - 335px)",
    },

    "& .MuiDataGrid-columnHeader": {
      "& .MuiDataGrid-columnHeaderCheckbox": {
        "& .MuiCheckbox-root:not(.Mui-checked) svg": {
          color: "#9B9B9B",
        },
      },

      "& .MuiDataGrid-columnHeaderTitleContainerContent": {
        "& span": {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },

        lineHeight: 1.5,
        whiteSpace: "normal",
      },

      "& .MuiDataGrid-iconButtonContainer": {
        background: "#efefef",
        position: "absolute",
        right: 0,
      },

      "&:not(.MuiDataGrid-columnHeaderCheckbox):not([data-field='icon'])": {
        padding: "5px 16px !important",
      },
    },

    "& [class*=MuiTablePagination] p": {
      margin: 0,
    },

    "& .MuiDataGrid-cell[data-field='icon'] svg": {
      color: "#757575",
    },

    "& .MuiDataGrid-cell": {
      alignItems: "center",
      display: "flex !important",
      maxHeight: "fit-content !important",
      overflow: "hidden",
      padding: "5px 16px !important",
      whiteSpace: `${wrapInline ? "nowrap" : "initial"} !important`,
      wordBreak: "break-word",
      "&[data-field='custom']": {
        padding: "0 6px !important",
        "& [class*='MuiIconButton']": {
          display: "none",
        },
      },
    },
    "& .MuiDataGrid-row:hover": {
      cursor: "pointer",
      "& [data-field='custom'] [class*='MuiIconButton']": {
        display: "flex",
        "& [class*='MuiSvgIcon']": {
          fontSize: "1.75rem",
        },
      },
      "&.row-cursor-default": {
        cursor: "default",
      },
    },

    "& .MuiDataGrid-root": {
      bottomBorder: "none",
      height: "100%",
      minHeight: "calc(100vh - 116px)",
    },

    "& .MuiDataGrid-viewport, .MuiDataGrid-row, .MuiDataGrid-renderingZone": {
      maxHeight: "fit-content !important",
    },

    "& .MuiDataGrid-virtualScroller > div.MuiDataGrid-virtualScrollerContent": {
      display: "flex !important",
      height: "fit-content !important",
    },

    "& .MuiDataGrid-virtualScroller > div.MuiDataGrid-virtualScrollerContent > div.MuiDataGrid-virtualScrollerRenderZone":
      {
        position: "relative !important",
      },

    "& .MuiDataGrid-cellCheckbox": {
      padding: "0 0 0 0px !important",
    },

    "& [data-field='icon']": {
      "& *": {
        overflow: "visible !important",
      },

      // maxWidth: "33px !important",
      // minWidth: "33px !important",
      overflow: "visible !important",
      padding: "0 0 0 0px !important",
    },
    "@media all and (-webkit-min-device-pixel-ratio:0)": {
      "& .MuiDataGrid-row": {
        display: "-webkit-box !important",
      },
    },
  }),
  row: ({ firstColumnIndex }) => ({
    [`& [data-colindex='${firstColumnIndex}']`]: {
      "& [class*='cellContent']": {
        fontWeight: 700,
      },
    },
    "&[class*='Mui-selected']": {
      backgroundColor: "#1976d214 !important",
    },
    borderColor: "#ececec",
  }),
  sectionHeader: {
    color: "#7f707d",
    fontSize: "18px",
  },
  sectionItem: {
    "& >[class*='MuiDataGrid-cellCheckbox']": {
      "& >[class*='MuiCheckbox-root']": {
        display: "none",
      },
    },
    "&:hover": {
      backgroundColor: "#ececec",
    },

    backgroundColor: "#f9f9f9",
  },
  sortableColumn: {
    "&:hover": {
      backgroundColor: "#ececec",
    },
  },
  title: {
    fontWeight: "bold",
  },
}))

export const useDynamicStyles = makeStyles(({ withPalette }) => ({
  root: ({ color }) => {
    return {
      color: withPalette(color),
      fontWeight: "bold",
      textTransform: "uppercase",
    }
  },
}))
